import axiosInstance from '../AxiosInstance';
import { fetchAllPagesVia } from '../paginated';

export function createLastUserCompany(payload, eventId?: string) {
    return axiosInstance.post('/businesses', payload, { params: eventId ? { eventId } : undefined });
}

export function listLastUserCompanies({ mine, scope, buyerMission, eventId }: { mine?: boolean; scope?: 'connect'; buyerMission?: boolean; eventId?: string } = {}) {
    const params: Record<string, string> = {};
    if (mine) params.mine = 'true';
    if (scope) params.scope = scope;
    if (buyerMission) params.buyerMission = 'true';
    if (eventId) params.eventId = eventId;
    // FAZ 5 / F5-10 — uc sayfalandi; ekranda sayfalama arayuzu yok, tum
    // sayfalar cekiliyor. Cagiran sozlesmesi (`{ data: [...] }`) DEGISMIYOR.
    return fetchAllPagesVia(axiosInstance, '/businesses', params);
}

export function listExhibitorCompanies() {
    return axiosInstance.get('/exhibitor-registrations');
}

export function listVisitorCompanies() {
    return axiosInstance.get('/visitor-businesses');
}

export function listEventVisitorCompanies(eventId) {
    return axiosInstance.get(`/visitor-businesses/events/${eventId}/businesses`);
}

export function syncEventVisitorCompanies(eventId) {
    return axiosInstance.post(`/visitor-businesses/events/${eventId}/sync`);
}

export function getLastUserCompany(companyId) {
    return axiosInstance.get(`/businesses/${companyId}`);
}

export function uploadLastUserCompanyLogo(file) {
    const formData = new FormData();
    formData.append('file', file);
    return axiosInstance.post('/businesses/logo', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
}

export function uploadLastUserCompanyCover(file) {
    const formData = new FormData();
    formData.append('file', file);
    return axiosInstance.post('/businesses/cover', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
}

/** Düzenleme formu için firmanın tam bilgisi (e-posta/telefon dahil; liste cevabında gizli). */
export function getLastUserCompanyEditDetails(companyId) {
    return axiosInstance.get(`/businesses/${companyId}/edit-details`);
}

export function updateLastUserCompany(companyId, payload) {
    return axiosInstance.patch(`/businesses/${companyId}`, payload);
}

export function deleteLastUserCompany(companyId) {
    return axiosInstance.delete(`/businesses/${companyId}`);
}

export function createMeetingRequest(companyId, payload) {
    return axiosInstance.post(`/lastuser-companies/${companyId}/meeting-requests`, payload);
}

export function listCompanyComments(companyId) {
    return axiosInstance.get(`/lastuser-companies/${companyId}/comments`);
}

export function createCompanyComment(companyId, payload) {
    return axiosInstance.post(`/lastuser-companies/${companyId}/comments`, payload);
}

export function updateCompanyComment(companyId, commentId, payload) {
    return axiosInstance.patch(`/lastuser-companies/${companyId}/comments/${commentId}`, payload);
}

export function deleteCompanyComment(companyId, commentId) {
    return axiosInstance.delete(`/lastuser-companies/${companyId}/comments/${commentId}`);
}

export function listMeetingRequests() {
    return axiosInstance.get('/lastuser-companies/meeting-requests');
}

export function createMeetingRequestMessage(requestId, payload) {
    return axiosInstance.post(`/lastuser-companies/meeting-requests/${requestId}/messages`, payload);
}

export function approveMeetingRequest(requestId: string) {
    return axiosInstance.post(`/lastuser-companies/meeting-requests/${requestId}/approve`);
}

export function rejectMeetingRequest(requestId: string) {
    return axiosInstance.post(`/lastuser-companies/meeting-requests/${requestId}/reject`);
}

export function listConversations() {
    return axiosInstance.get('/lastuser-companies/messages');
}

export function listConversationMessages(conversationId) {
    return axiosInstance.get(`/lastuser-companies/messages/${conversationId}`);
}

export function sendConversationMessage(conversationId, payload) {
    return axiosInstance.post(`/lastuser-companies/messages/${conversationId}`, payload);
}

export function createDirectConversation(userId) {
    return axiosInstance.post(`/lastuser-companies/messages/users/${userId}`);
}

export function deleteConversation(conversationId) {
    return axiosInstance.delete(`/lastuser-companies/messages/${conversationId}`);
}

export function listUsers() {
    return axiosInstance.get('/users');
}

export function listBusinessDocuments(companyId) {
    return axiosInstance.get(`/businesses/${companyId}/documents`);
}

export function createBusinessDocument(companyId, formData) {
    return axiosInstance.post(`/businesses/${companyId}/documents`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
}

export function updateBusinessDocument(companyId, documentId, formData) {
    return axiosInstance.patch(`/businesses/${companyId}/documents/${documentId}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
}

export function deleteBusinessDocument(companyId, documentId) {
    return axiosInstance.delete(`/businesses/${companyId}/documents/${documentId}`);
}

export function listBusinessDepartments(businessId: string) {
    return axiosInstance.get('/departments', { params: { businessId } });
}

export function createBusinessUser(payload: {
    businessId: string;
    email: string;
    firstName?: string;
    lastName?: string;
    phoneNumber?: string;
    password?: string;
    role?: string;
    departmentId?: string;
    departmentName?: string;
    roleNames?: string[];
    isOrganizationMember?: boolean;
    membershipBranch?: string | null;
    isBusinessRepresentative?: boolean;
}) {
    return axiosInstance.post('/business-users', payload);
}

export function resolveExistingBusinessUser(payload: { businessId: string; email: string }) {
    return axiosInstance.post('/business-users/resolve-existing', payload);
}

export function attachExistingBusinessUser(payload: { businessId: string; email: string }) {
    return axiosInstance.post('/business-users/attach-existing', payload);
}

export function updateBusinessUser(assignmentId: string, payload: {
    firstName?: string;
    lastName?: string;
    phoneNumber?: string;
    role?: string;
    departmentId?: string | null;
    roleNames?: string[];
    isOrganizationMember?: boolean;
    membershipBranch?: string | null;
    isBusinessRepresentative?: boolean;
}) {
    return axiosInstance.patch(`/business-users/${assignmentId}`, payload);
}

export function deleteBusinessUser(assignmentId: string) {
    return axiosInstance.delete(`/business-users/${assignmentId}`);
}

/** Personel adi/e-postasi ile eslesen firmalarin kimlikleri (Firmalar sayfasi "Personel ara"). */
export function listBusinessIdsByStaffSearch(search: string) {
    return axiosInstance.get<string[]>('/business-users/business-ids', { params: { search } });
}
